import createIframeCodeValidator from './create-iframe-code-validator';
import createIframeUrlValidator from './create-iframe-url-validator';

export default {
  createIframeCodeValidator,
  createIframeUrlValidator,
};
